/* eslint-disable react-hooks/exhaustive-deps */
// Modules
import React, { useEffect, useMemo, useState } from 'react'

// Application
import { useActivateHook, useRecoverHook } from 'hooks'
import { Contact } from 'typings'

// Components
import { SelectContact, SelectContactInitial } from 'components/Presenters/SelectContact'
import { useLoginContext } from 'context'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { mapFromResetContacts } from 'utils/contacts'
import { ROUTES_PATH } from 'constants/routesPath'
import { useHistory } from 'react-router-dom'

export const SelectContactWrapper: React.VFC = () => {
    const recover = useRecoverHook()
    const activeAccount = useActivateHook()
    const history = useHistory()
    const { operations } = useLoginContext()
    const [isLoading, setIsLoading] = useState(false)

    const lsAuthData = operations.getAuthData()

    const isLogged = useMemo(() => !!lsAuthData?.token, [lsAuthData])
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)
    const usernameRecover = JSON.parse(sessionStorage.getItem('@LiviaRecoverPassword:Username')!)
    const username = JSON.parse(sessionStorage.getItem('@LiviaAuth:SignUpPersonalData')!)
    const federalTaxId = sessionStorage.getItem('@Livia/federalTaxId')

    const userCpf = useMemo(() => biometyDataLS?.federalTaxId ?? usernameRecover ?? username?.cpf ?? federalTaxId, [
        biometyDataLS,
        usernameRecover,
        username,
        federalTaxId,
    ])

    const getContactsToReset = async () => {
        setIsLoading(true)
        const contactsToReset = await activeAccount.getContactsToReset(userCpf)
        recover.setContacts(userCpf, mapFromResetContacts(contactsToReset))
        if (!contactsToReset.length) {
            history.push(ROUTES_PATH.SIGN_UP_MDM_SELECT_CONTACT)
        }
        setIsLoading(false)
    }

    const handleSubmit = async (values: SelectContactInitial) => {
        try {
            recover.setSubmitting(true)
            if (values.contact?.type) {
                !recover.username && recover.setUsername(userCpf)
                recover.setContact(values.contact)
                await recover.sendResetToken(values.contact, userCpf)
                recover.setSubmitting(false)
                recover.nextStep()
            }
        } catch (err) {
            recover.setSubmitting(false)
            recover.moveToError('/erro-de-conexao')
        }
    }

    const contacts: Array<Contact> = useMemo(() => (recover.contacts?.length ? recover.contacts : []), [recover.contacts])

    useEffect(() => {
        if (userCpf) {
            getContactsToReset()
        } else {
            history.push(ROUTES_PATH.LOGIN)
        }
    }, [userCpf])

    return (
        <SelectContact
            contacts={contacts}
            handleSubmit={handleSubmit}
            initialValues={{ contact: contacts[0] }}
            isLoading={isLoading}
            isLogged={isLogged}
            isSubmitting={recover.isSubmitting}
        />
    )
}
